export const ENDPOINTS = {
  ROLES: '/api/v1/roles',
};

// unique query keys for each API
export enum EndpointQueryKeys {
  GET_ROLES = 'roles',
  EDIT_ROLES = 'editRoles',
}
